import styled from 'styled-components'
import { G } from '@/components/gold/theme'

export const Footer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 14px;
  padding: 20px 0 10px;
`

export const Copy = styled.p`
  margin: 0;
  font-size: 11px;
  font-weight: 700;
  color: ${G.sand};
`
